<template>
    <div v-if="reCaptchaValue.enabled">
        <b-field class="mb-0" :type="{'is-danger': !valid}" :message="{ 'Bu alanı işaretlemelisin': !valid }">
            <vue-recaptcha 
                :sitekey="GOOGLE_RECAPTCHA_SITEKEY" 
                :loadRecaptchaScript="true"
                @verify="onVerify"
                @expired="onExpired">
            </vue-recaptcha>
        </b-field>
    </div>
</template>

<script>
    import apiConfigs from '@/services/config'
    import VueRecaptcha from 'vue-recaptcha';
    import { KEYS } from '@/constants/keys'

    export default {
        name: "Recaptcha",
        props: [ 'type', 'valid' ],
        components: { VueRecaptcha },
        data() {
            return {
                reCaptchaValue: {
                    key: null,
                    enabled: true
                },
                GOOGLE_RECAPTCHA_SITEKEY: KEYS.GOOGLE_RECAPTCHA_SITEKEY
            }
        },
        methods: {
            onVerify: function (response) {
                this.reCaptchaValue.key = response;
                this.$emit('verify', this.reCaptchaValue)
            },
            onExpired: function () {
                this.onVerify(null);
            },

            toDisabledTest() {
                this.reCaptchaValue.enabled = false;
                this.onVerify(null);
            }
        },
        created(){
            let params = {
                type: this.type
            }

            //this.toDisabledTest();

            apiConfigs.serviceWrapper(apiConfigs.serviceConfigs.settings, apiConfigs.serviceConfigs.settings.recaptchas, params)
                .then((response) => {
                    let data = response.data;
                    if (data.statusCode == 200) {

                        this.reCaptchaValue.enabled = data.result.recaptchaEnabled;

                        if (!this.reCaptchaValue.enabled)
                            this.onVerify(null);
                    }
                })
        }
    }
</script>